export default __webpack_public_path__ + "static/media/rarity6.f26e8180.mp4";